module.exports = __webpack_public_path__ + "img/features-split-image-03.61ef3c22.jpg";